var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/polls/poll-footer.tsx";
import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { fetchPoll, vote } from 'soapbox/actions/polls';
import { useAppDispatch } from 'soapbox/hooks';
import RelativeTimestamp from '../relative-timestamp';
import { Button, HStack, Stack, Text, Tooltip } from '../ui';
const messages = defineMessages({
  closed: {
    "id": "poll.closed",
    "defaultMessage": "Closed"
  },
  nonAnonymous: {
    "id": "poll.non_anonymous.label",
    "defaultMessage": "Other instances may display the options you voted for"
  }
});

const PollFooter = _ref => {
  let {
    poll,
    showResults,
    selected
  } = _ref;
  const dispatch = useAppDispatch();
  const intl = useIntl();

  const handleVote = () => dispatch(vote(poll.id, Object.keys(selected)));

  const handleRefresh = e => {
    dispatch(fetchPoll(poll.id));
    e.stopPropagation();
    e.preventDefault();
  };

  const timeRemaining = poll.expired ? intl.formatMessage(messages.closed) : /*#__PURE__*/React.createElement(RelativeTimestamp, {
    weight: "medium",
    timestamp: poll.expires_at,
    futureDate: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 5
    }
  });
  let votesCount = null;

  if (poll.voters_count !== null && poll.voters_count !== undefined) {
    votesCount = /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "poll.total_people",
      defaultMessage: "{count, plural, one {# person} other {# people}}",
      values: {
        count: poll.get('voters_count')
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 18
      }
    });
  } else {
    votesCount = /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "poll.total_votes",
      defaultMessage: "{count, plural, one {# vote} other {# votes}}",
      values: {
        count: poll.get('votes_count')
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 18
      }
    });
  }

  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    "data-testid": "poll-footer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 5
    }
  }, !showResults && (poll === null || poll === void 0 ? void 0 : poll.multiple) && /*#__PURE__*/React.createElement(Button, {
    onClick: handleVote,
    theme: "primary",
    block: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "poll.vote",
    defaultMessage: "Vote",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(HStack, {
    space: 1.5,
    alignItems: "center",
    wrap: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }, poll.pleroma.get('non_anonymous') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    text: intl.formatMessage(messages.nonAnonymous),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "poll.non_anonymous",
    defaultMessage: "Public poll",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 13
    }
  }, "\xB7")), showResults && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: "text-gray-600 underline",
    onClick: handleRefresh,
    "data-testid": "poll-refresh",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "poll.refresh",
    defaultMessage: "Refresh",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 13
    }
  }, "\xB7")), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 9
    }
  }, votesCount), poll.expires_at && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 13
    }
  }, "\xB7"), /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    theme: "muted",
    "data-testid": "poll-expiration",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 13
    }
  }, timeRemaining))));
};

export default PollFooter;